
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.405 13.27H3.488a2.188 2.188 0 01-2.187-2.187V1.167a.44.44 0 01.437-.438.44.44 0 01.438.438v9.916c0 .724.589 1.313 1.312 1.313h9.917a.44.44 0 01.437.437.44.44 0 01-.437.438z","fill":"#fff","stroke":"#fff","stroke-width":".5"}}),_c('path',{attrs:{"d":"M3.488 10.354a.444.444 0 01-.286-.105.441.441 0 01-.047-.618l2.678-3.127a1.614 1.614 0 011.155-.56 1.63 1.63 0 011.196.467l.554.554a.753.753 0 00.542.216c.205-.006.391-.1.525-.257l2.678-3.127a.441.441 0 01.618-.046c.181.157.204.431.047.618L10.47 7.496a1.614 1.614 0 01-1.155.56 1.63 1.63 0 01-1.195-.467l-.549-.554a.73.73 0 00-.542-.216.713.713 0 00-.525.257l-2.678 3.126a.466.466 0 01-.338.152z","fill":"#fff","stroke":"#fff","stroke-width":".5"}})])
          )
        }
      }
    